import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import LoaderFull from 'loader-full'

const useStyles = makeStyles(theme => ({
    root: theme.loadingDiv
}))

interface CenteredLoaderProps {
    dataTestId?: string
    loading: boolean
    size?: string
}

/**
 * Shared full-area loader using the theme's centered LoaderFull position.
 */
export const CenteredLoader = ({ dataTestId, loading, size }: CenteredLoaderProps) => {
    const classes = useStyles()
    if (!loading) return null

    return (
        <div className={classes.root}>
            <LoaderFull {...{ 'data-test-id': dataTestId }} size={size} />
        </div>
    )
}
